// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-editor.ql-blank:before{font-family:Heebo;font-style:normal;font-weight:400;font-size:15.2px;line-height:22px;color:#d1d2db}.ql-editor{height:10rem}.ql-container.ql-snow{background:#fff;border:1px solid #d1d2db;box-sizing:border-box;border-radius:0 0 4.64px 4.64px}.ql-toolbar.ql-snow{background:#fff;border:1px solid #d1d2db;box-sizing:border-box;border-radius:4.64px 4.64px 0 0}", ""]);
// Exports
module.exports = exports;
